import {Component, OnInit, ViewChild} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {HumanInteractionService} from '../../../services/human-interaction.service';
import {ActivatedRoute, Router} from '@angular/router';
import {InteractionQueueConfigService} from '../../../services/interaction-queue-config.service';
import {BusinessProcessService} from '../../../services/business-process.service';
import {AccessControlService} from '../../../services/access-control.service';
import {error} from 'selenium-webdriver';
import {AdminService} from '../../../services/admin.service';
import {QueueColumnsPreviewModalComponent} from '../common/queue-columns-preview-modal/queue-columns-preview-modal.component';
import {GenericModalService} from '../../../services/generic-modal.service';
import {DropdownMultiselectComponent} from '../../../common/dropdown-multiselect/dropdown-multiselect.component';
import {BehaviorSubject, config} from 'rxjs';
import {moveItemInArray} from '@angular/cdk/drag-drop';
import {EditQueueColumnModalComponent} from '../common/edit-queue-column-modal/edit-queue-column-modal.component';
import {take} from 'rxjs/operators';
import {EditQueueColorModalComponent} from '../common/edit-queue-color-modal/edit-queue-color-modal.component';
import {CustomValidator} from '../../../services/custom-validator';
import {EditQueueOverflowModalComponent} from '../common/edit-queue-overflow-modal/edit-queue-overflow-modal.component';
import {EditQueueMetadataModalComponent} from '../common/edit-queue-metadata-modal/edit-queue-metadata-modal.component';
import {Utils} from '../../../services/utils';

@Component({
  selector: 'app-custom-interaction-queue-config',
  templateUrl: './custom-interaction-queue-config.component.html',
  styleUrls: ['./custom-interaction-queue-config.component.css']
})
export class CustomInteractionQueueConfigComponent implements OnInit {

  // @ViewChild('childUsersDropDown', {static: false}) childUsersDropDown: DropdownMultiselectComponent;
  componentForm: FormGroup;
  customQueueConfig;
  availableBusinessProcess;
  availableStates;
  availableUsers;
  availableGroups;
  availableCustomInteractionQueues;
  errorMessage = '';
  successMessage = '';
  submitted;
  pleaseWait;
  maxLengthName = 30;
  hasName = false;
  divState = true;
  hasColumns = false;
  availableColumns;
  pageIndex = 1;

  dmSelectedUsers = [];
  dmSelectedGroups = [];
  disableUserDropdown$ = new BehaviorSubject<any>(true);
  disableGroupDropdown$ = new BehaviorSubject<any>(true);
  orderDirections = [{ orderId: 1, orderName: 'Crescente' }, { orderId: 2, orderName: 'Decrescente' }];

  isNew = false;
  routerLink = this.router.url;

  get formData() { return this.componentForm.controls; }
  get overflowError() {
    return this.formData.overflowValues.value.length > 0 &&
      (this.formData.maxCountInstances.value == 0 || this.formData.maxCountInstances.value == null);
  }

  constructor(private formBuilder: FormBuilder, private interactionQueueConfig: InteractionQueueConfigService, private router: Router,
              private admService: AdminService, private accessControl: AccessControlService, private bpService: BusinessProcessService,
              private route: ActivatedRoute, private modalService: GenericModalService) { }

  ngOnInit() {
    this.pleaseWait = true;
    this.createForm();
    this.loadContent();
    this.getAllBpPublished();
    this.loadGroups();
  }

  editingItem(customId) {
    this.errorMessage = '';
    const filter = { queueName: null, businessProcessId: null, pageIndex: this.pageIndex };
    this.interactionQueueConfig.getCustomInteractionQueueConfigList(filter)
      .subscribe(result => {
        this.customQueueConfig = result.items.filter(f => f.id == customId)[0]; // pego o fieldColumns
        const res = result.items.filter(f => f.id == customId)[0];
        if (res) {
          this.hasName = true;

          this.availableCustomInteractionQueues = result.items.filter(f => f.businessProcessId == res.businessProcessId);
          this.getStates(res);
          this.setStateValidator(!res.isDefault);
          this.divState = !res.isDefault;

          if (!res.isDefault) { // se for default, eu estou carregando dentro de getStates
            this.loadUsersOnState(res);
          }

          res.fieldColumns = res.fieldColumns.sort(function (a, b) {
            return a.columnOrder - b.columnOrder;
          });

          for (let i = 0; i < res.fieldColumns.length; i++) {
            res.fieldColumns[i].isEnabled = true;
          }

          this.complementFieldColumns(res.fieldColumns);

          if (res.users) {
            this.dmSelectedUsers = res.users.map(m => m.userId);
          }
          this.dmSelectedGroups = res.groups.map(m => m.groupId);

          this.componentForm.patchValue({
            id: res.id,
            name: res.name,
            businessProcessId: res.businessProcessId,
            stateId: res.stateId,
            isDefault: res.isDefault,
            columns: res.fieldColumns,
            colors: res.colors,
            maxCountInstances: res.maxCountInstances,
            orderByColumn: res.orderByColumn,
            orderByColumnId: res.orderByColumn ? res.orderByColumn.id : 0,
            orderDirection: res.orderDirection,
            hasOrdering: res.orderByColumn && res.orderDirection !== 0 && res.fieldColumns.length > 0
          });

          this.hasColumns = res.fieldColumns.filter(f => f.isEnabled == true).length > 0;
          // this.hasOrdering = res.orderByColumn && res.orderDirection !== 0 && res.fieldColumns.length > 0;
          this.availableColumns = res.fieldColumns.filter(f => f.isEnabled == true);

          this.getOverflowCustomIntQueues(res.id);
          this.getMetadataValues(res.id);

        }
      }, error1 => {
        this.errorMessage = error1;
      });
  }

  loadContent() {
    this.route.params.subscribe(params => {
      // if (!isNaN(params['pageIndex'])) {
      //   this.pageIndex = parseInt(params['pageIndex'], 10);
      // }
      if (localStorage.getItem('customQueuePageIndex')) {
        if (!isNaN(parseInt(localStorage.getItem('customQueuePageIndex'), 10))) {
          this.pageIndex = parseInt(localStorage.getItem('customQueuePageIndex'), 10);
        } else {
          this.errorMessage = 'Ocorreu um erro ao carregar as informações';
          return;
        }
      }

      if (this.routerLink.indexOf('/configCustomQueue/') > -1) {
        if (!isNaN(params['customId'])) {
          this.isNew = params['customId'] === 0;
          if (params['customId'] !== 0 ) {
            // editando
            this.editingItem(params['customId']);
          } else {
            this.errorMessage = 'O parâmetro informado não é válido.';
          }
        } else {
          this.errorMessage = 'O parâmetro informado não é válido.';
        }
      } else if (this.routerLink == '/newConfigCustomQueue') {
        // nova fila
        this.isNew = true;
        this.hasColumns = true;

        const systemFields = [
          { name: 'Id da instância', type: 1 }, { name: 'Usuário', type: 8 }, { name: 'Tempo em fila', type: 5 }
        ];

        this.formData.columns.setValue([]);
        const fields = [];

        for (let i = 0; i < systemFields.length; i++) {

          const field = {
            id: 0,
            name: systemFields[i].name,
            columnOrder: i,
            customInteractionQueueConfigId: 0,
            type: 1,
            systemField: systemFields[i].type,
            businessProcessFieldId: 0,
            isEnabled: true
          };
          fields.push(field);
        }
        this.complementFieldColumns(fields);
        this.formData.columns.setValue(fields);
        this.availableColumns = fields.filter(f => f.isEnabled == true);
      }
    });
  }

  complementFieldColumns(fieldColumns) {
    if (fieldColumns.length < 6)  {
      for (let i = fieldColumns.length; i < 6; i++) {
        fieldColumns.push({
          businessProcessFieldId: 0,
          columnOrder: i,
          customInteractionQueueConfigId: 0,
          id: 0,
          name: `Coluna ${i + 1}`,
          systemField: 0,
          type: 0,
          isEnabled: false
        });
      }
    }
    // return fieldColumns;
  }

  loadUsersOnState(element) {
    this.errorMessage = '';
    this.cleanSelectedUser();
    this.dmSelectedGroups = [];
    this.disableGroupDropdown$.next(true);

    if (element !== undefined) {
      this.accessControl.getUsersWithEffectivePermissionOnState([ element.stateId ], 'Interagir').subscribe(users => {
        if (users.length > 0) {
          this.disableUserDropdown$.next(false);
          this.availableUsers = users;
        }
        this.disableGroupDropdown$.next(false);
      }, error1 => {
        this.errorMessage = error1;
      });
    }
  }

  loadUsersOnAnyState(stateIds: number[]) {
    this.errorMessage = '';
    this.availableUsers = [];
    if (this.componentForm.controls.businessProcessId.value !== null) {
      this.disableGroupDropdown$.next(false);
    }

    this.accessControl.getUsersWithEffectivePermissionOnAnyState(stateIds, 'Interagir')
    .subscribe(users => {
      if (users.length > 0) {
        this.availableUsers = users;
        this.disableUserDropdown$.next(false);
      } else {
        this.disableUserDropdown$.next(true);
      }
    }, error1 => {
      this.errorMessage = error1;
    });
  }

  loadGroups() {
    this.errorMessage = '';
    this.admService.loadGroupList().subscribe(groups => {
      this.availableGroups = groups.filter(f => f.enabled === true);
      this.pleaseWait = false;
    }, error1 => {
      this.errorMessage = error1;
    });
  }

  cleanSelectedUser() {
    this.availableUsers = [];
    this.dmSelectedUsers = [];
    this.disableUserDropdown$.next(true);
  }

  createForm() {
    this.componentForm = this.formBuilder.group({
      id: 0,
      name: [ null, Validators.compose([ Validators.required, Validators.maxLength(this.maxLengthName), this.validateSpecialChars ])],
      businessProcessId: [ null, Validators.required],
      stateId: [{ value: 0, disabled: true}],
      isDefault: false,
      columns: [[]],
      colors: [[]],
      maxCountInstances: [null, Validators.compose([Validators.max(2147483647), CustomValidator.numericButNotRequired])],
      overflowValues: [[]],
      metadataValues: [[]],
      orderByColumn: [],
      orderByColumnId: null,
      orderDirection: null,
      hasOrdering: false
    });
  }

  preventChars(e) {
    console.log(e);
    switch (e.key.toLowerCase()) {
      case 'e':
      case '-':
      case '+': {
        return false;
      }
    }
  }

  getAllBpPublished() {
    this.availableBusinessProcess = null;
    this.errorMessage = '';
    this.bpService.getAllBusinessProcessesPublished().subscribe(s => {
      this.availableBusinessProcess = s;
    }, error1 => {
      this.errorMessage = error1;
    });
  }

  getOverflowCustomIntQueues(configId) {
    this.errorMessage = '';
    this.interactionQueueConfig.getOverflowCustomIntQueues(configId).subscribe(res => {
      for (let i = 0; i < res.length; i++) {
        let queue = this.availableCustomInteractionQueues.filter(f => f.id == res[i].overflowCustomInteractionQueueConfigId)[0];
        res[i].overflowCustomInteractionQueueConfigName = queue.name;
      }
      this.formData.overflowValues.setValue(res);
    }, error1 => {
      this.errorMessage = error1;
    });
  }

  getMetadataValues(configId) {
    this.errorMessage = '';
    this.interactionQueueConfig.getAllCustomIntQueueMetadataValues(configId).subscribe(res => {
      this.formData.metadataValues.setValue(res);
    }, error1 => {
      this.errorMessage = error1;
    });
  }

  getStates(element) {
    this.errorMessage = '';
    this.availableStates = [];
    this.componentForm.controls.stateId.setValue(null);
    this.cleanSelectedUser();
    this.dmSelectedGroups = [];
    this.disableGroupDropdown$.next(true);

    if (element !== undefined) {
      const filter = { queueName: null, businessProcessId: element.businessProcessId, pageIndex: 1 };
      this.interactionQueueConfig.getCustomInteractionQueueConfigList(filter).subscribe(result => {
        this.availableCustomInteractionQueues = result.items
          .filter(f => f.businessProcessId == element.businessProcessId && f.isDefault == false);
      }, error1 => this.errorMessage = error1);

      this.bpService.getStatesByBusinessProcessId(element.businessProcessId).subscribe(result => {
        // se for fila padrão, não devo carregar os estados e devo carregar os usuários
        // e habilitar novamente os grupos
        if (this.formData.isDefault.value) {
          this.loadUsersOnAnyState(result.map(m => m.stateId));
          this.disableGroupDropdown$.next(false);
        } else {
          this.availableStates = result;
        }
        this.setStateValidator(!this.formData.isDefault.value);
      }, error1 => {
        this.errorMessage = error1;
      });
    } else {
      this.availableCustomInteractionQueues = [];
      this.setStateValidator(false);
    }
  }

  getSelectedUsers(element) {
    this.dmSelectedUsers = element;
  }

  getSelectedGroups(element) {
    this.dmSelectedGroups = element;
  }

  enableIsDefaultField() {
    const name = this.formData.name.value.toString().trim();
    this.hasName = name.length > 0;
  }

  setStateValidator(enable: boolean) {
    if (enable) {
      this.componentForm.get('stateId').setValidators([ Validators.required ]);
      this.componentForm.get('stateId').enable();
    } else {
      this.componentForm.get('stateId').clearValidators();
      this.componentForm.get('stateId').disable();
    }
    this.componentForm.get('stateId').updateValueAndValidity();
  }

  checkDefault(element) {
    this.errorMessage = '';
    let stateIds = [];
    if (element.target.checked && this.availableStates && this.availableStates.length > 0) {
      stateIds = this.availableStates.map(m => m.stateId);
    }
    this.availableStates = [];
    this.formData.stateId.setValue(null);

    this.divState = !element.target.checked;

    if (element.target.checked) {
      this.formData.name.setValue(`${this.formData.name.value}*`);
      this.formData.maxCountInstances.setValue(null);
      this.formData.metadataValues.setValue([]);
      this.formData.overflowValues.setValue([]);
      this.setStateValidator(false);
      this.loadUsersOnAnyState(stateIds);
    } else {
      const name = this.formData.name.value;
      if (name.substring(name.length - 1) == '*') {
        this.formData.name.setValue(name.slice(0, -1));
      }
      // se eu desmarco o flag de fila padrão, devo recarregar o combo de estados
      const filter = { businessProcessId: this.formData.businessProcessId.value, isDefault: element.target.checked};
      this.getStates(filter);
    }
  }

  enableOrdering(element) {
    this.errorMessage = '';
    if (element.target.checked) {
      this.componentForm.get('orderByColumnId').setValidators([ Validators.required ]);
      this.componentForm.get('orderDirection').setValidators([ Validators.required ]);
      this.formData.orderDirection.setValue('1');
      if (this.availableColumns && this.availableColumns.length > 0) {
        this.formData.orderByColumnId.setValue('0');
        this.formData.orderByColumn.setValue(this.availableColumns.filter(f => f.columnOrder === 0)[0]);
      }
    } else {
      this.componentForm.get('orderByColumnId').clearValidators();
      this.componentForm.get('orderDirection').clearValidators();
      this.formData.orderByColumnId.setValue(null);
      this.formData.orderDirection.setValue(null);
    }
    this.componentForm.updateValueAndValidity();
  }

  onSave() {
    this.submitted = true;
    this.errorMessage = '';
    let raw = this.componentForm.getRawValue();
    raw.users = this.availableUsers.filter(item => {
      return (this.dmSelectedUsers.indexOf(item.userId) > -1);
    });
    raw.groups = this.availableGroups.filter(item => {
      return (this.dmSelectedGroups.indexOf(item.groupId) > -1);
    });
    raw = this.removeExtensionData(raw);
    const columns = raw.columns.filter(f => f.isEnabled === true);

    for (let i = 0; i < columns.length; i++) {
      columns[i].columnOrder = i;
    }

    const config = {
      id: raw.id,
      name: raw.name,
      businessProcessId: raw.businessProcessId,
      stateId: raw.stateId || 0,
      users: raw.users,
      groups: raw.groups,
      fieldColumns: columns,
      colors: raw.colors,
      isDefault: raw.isDefault,
      orderDirection: raw.hasOrdering ? parseInt(raw.orderDirection, 10) : 0,
      orderByColumn: raw.hasOrdering ? raw.orderByColumn : null,
      metadataValues: raw.metadataValues,
      overflowQueues: raw.overflowValues,
      maxCountInstances: raw.maxCountInstances == 0 ? null : raw.maxCountInstances
    };

    if (this.isNew) {
      delete config.id;
      this.interactionQueueConfig.createInteractionQueueConfig(config).subscribe(result => {
        this.isNew = false;
        this.componentForm.controls.id.setValue(result);
        this.editingItem(result);
        this.successMessage = 'Configuração criada com sucesso';
        setTimeout(() => {
          this.submitted = false;
          this.successMessage = '';
        }, 2000);
      }, error1 => {
        this.errorMessage = error1;
        this.submitted = false;
        console.error(error1);
      });
    } else {
      this.interactionQueueConfig.updateInteractionQueueConfig(config).subscribe(result => {
        this.successMessage = 'Configuração atualizada com sucesso';
        this.editingItem(config.id);
        setTimeout(() => {
          this.successMessage = '';
          this.submitted = false;
        }, 2000);
      }, error1 => {
        this.errorMessage = error1;
        this.submitted = false;
        console.error(error1);
      });
    }
  }

  removeExtensionData(item) {
    const key = 'extensionData';
    delete item[key];
    if (item['colors'].length > 0) {
      item['colors'] = this.getNewArray(item['colors'], [key]);
    }
    if (item['columns'].length > 0) {
      item['columns'] = this.getNewArray(item['columns'], [key]);
    }
    if (item['groups'].length > 0) {
      item['groups'] = this.getNewArray(item['groups'], [key]);
    }
    if (item['overflowValues'].length > 0) {
      item['overflowValues'] = this.getNewArray(item['overflowValues'], [key]);
    }
    if (item['users'].length > 0) {
      item['users'] = this.getNewArray(item['users'], [key]);
    }
    if (item['orderByColumn']) {
      delete item['orderByColumn'][key];
    }
    if (item['metadataValues']) {
      item['metadataValues'] = this.getNewArray(item['metadataValues'], [key]);
      for (let i = 0; i < item['metadataValues'].length; i++) {
        delete item['metadataValues'][i].structure.extensionData;
      }
    }
    return item;
  }

  getNewArray(array, keys = []) {
    return array.map(obj => Utils.mapOut(obj, keys));
  }

  updateOrderByColumn() {
    this.errorMessage = '';
    const id = parseInt(this.formData.orderByColumnId.value, 10);
    const column = this.formData.columns.value.filter(f => f.id == id)[0];

    this.formData.orderByColumn.setValue(column);
  }

  onBack() {
    this.router.navigate(['/customInteractionQueueConfig']);
  }

  /* colunas */
  columnsPreview: any = QueueColumnsPreviewModalComponent;
  openColumnsPreview() {
    this.errorMessage = '';
    let enabledColumns = this.formData.columns.value.filter(c => c.isEnabled);
    this.modalService.showObjModal(this.columnsPreview, 'Pré-visualização', enabledColumns);
  }

  drop(event) {
    this.errorMessage = '';
    let oldColumnOrder = this.formData.columns.value[event.previousIndex].columnOrder;
    let newColumnOrder = this.formData.columns.value[event.currentIndex].columnOrder;

    this.formData.columns.value[event.currentIndex].columnOrder = oldColumnOrder;
    this.formData.columns.value[event.previousIndex].columnOrder = newColumnOrder;
    moveItemInArray(this.formData.columns.value, event.previousIndex, event.currentIndex);
    this.availableColumns = this.formData.columns.value.filter(f => f.isEnabled == true);

  }

  destEditColumn: any = EditQueueColumnModalComponent;
  editColumn(column) {
    this.errorMessage = '';
    let param = {bps: this.availableBusinessProcess, column: column, selectedBp: this.formData.businessProcessId.value};
    const result$ = this.modalService.showObjModal(this.destEditColumn, 'Configuração da apresentação dos campos', param);
    if (result$) {
      result$.asObservable()
        .pipe(take(1))
        .subscribe((result) => {
          let itemIndex = this.formData.columns.value.findIndex(item => item.columnOrder == result.columnOrder);
          this.formData.columns.value[itemIndex] = result;

          this.hasColumns = this.formData.columns.value.filter(f => f.isEnabled == true).length > 0;
          this.availableColumns = this.formData.columns.value.filter(f => f.isEnabled == true);
          if (!this.hasColumns) {
            this.formData.hasOrdering.setValue(this.hasColumns);
          } else {
            // se atualizou o nome da coluna, devo atualizar a célula selecionada
            if (this.formData.hasOrdering.value) {
              // verificar se a celula selecionada é a mesma da editada... se for, devo atualizar orderByColumn
              if (this.formData.orderByColumn.value.id == result.id) {
                if (result.isEnabled) {
                  this.formData.orderByColumn.setValue(result);
                } else {
                  this.formData.orderByColumn.setValue(null);
                }
              }
            }
          }
        });
    } else {
      this.errorMessage = 'Erro: Sessão expirada.';
    }
  }

  /* Faixa de cores */
  destEditColor: any = EditQueueColorModalComponent;
  editColor(itemColor: any) {
    this.errorMessage = '';
    let param = {bps: null, color: itemColor, isCustom: true};
    const result$ = this.modalService.showObjModal(this.destEditColor, 'Configuração da faixa de cores', param);
    if (result$) {
      result$.asObservable()
        .pipe(take(1))
        .subscribe((result) => {
          let itemIndex = this.formData.colors.value
            .findIndex(item =>
              item.businessProcessId == result.oldColor.businessProcessId &&
              item.stateId == result.oldColor.stateId &&
              item.color == result.oldColor.color
            );
          this.formData.colors.value[itemIndex] = result.newColor;
          this.componentForm.updateValueAndValidity();
        });
    } else {
      this.errorMessage = 'Erro: Sessão expirada.';
    }
  }

  removeColor(itemColor: any) {
    this.errorMessage = '';
    let alert: any;
    alert = this.modalService.showConfirmModal('Confirmação de Exclusão de Cor',
      `Confirma a exclusão da cor?`);
    alert.then((result) => {
      if (result.value) {
        this.formData.colors.value.splice(this.formData.colors.value.indexOf(itemColor), 1);
      }
    });


  }

  addColor() {
    this.errorMessage = '';
    let param = {bps: null, color: null, isCustom: true};
    const result$ = this.modalService.showObjModal(this.destEditColor, 'Configuração da faixa de cores', param);
    if (result$) {
      result$.asObservable()
        .pipe(take(1))
        .subscribe((result) => {
          this.formData.colors.value.push(result.newColor);
        });
    } else {
      this.errorMessage = 'Erro: Sessão expirada.';
    }
  }

  destEditOverflow: any = EditQueueOverflowModalComponent;
  addOverflow() {

    this.errorMessage = '';
    let queuesConfigIds: number[] =
      this.formData.overflowValues.value.map(m => parseFloat(m.overflowCustomInteractionQueueConfigId));

    let configs = this.getOverflowConfigsParam()
      .filter(f => queuesConfigIds.indexOf(f.id) == -1);

    let param = {
      availableConfig: configs,
      overflow: null,
      existingOrders: this.formData.overflowValues.value.map(m => parseFloat(m.order)),
      customInteractionQueueConfigId: this.customQueueConfig ? this.customQueueConfig.id : undefined
    };

    const result$ = this.modalService.showObjModal(this.destEditOverflow, 'Configuração de transbordo', param);
    if (result$) {
      result$.asObservable()
        .pipe(take(1))
        .subscribe((result) => {
          this.formData.overflowValues.value.push(result.newOverflow);
          console.log(result.newOverflow);
        });
    } else {
      this.errorMessage = 'Erro: Sessão expirada.';
    }
  }

  editOverflow(itemOverflow) {
    this.errorMessage = '';
    let queuesConfigIds: number[] =
      this.formData.overflowValues.value.map(m => parseFloat(m.overflowCustomInteractionQueueConfigId))
        .filter(f => f !== parseFloat(itemOverflow.overflowCustomInteractionQueueConfigId));

    let configs = this.getOverflowConfigsParam()
      .filter(f => queuesConfigIds.indexOf(f.id) == -1);

    let param = {
      availableConfig: configs,
      overflow: itemOverflow,
      existingOrders: this.formData.overflowValues.value
        .filter(f =>
          parseFloat(f.overflowCustomInteractionQueueConfigId) !== parseFloat(itemOverflow.overflowCustomInteractionQueueConfigId))
        .map(m => parseFloat(m.order))
    };

    const result$ = this.modalService.showObjModal(this.destEditOverflow, 'Configuração de transbordo', param);
    if (result$) {
      result$.asObservable()
        .pipe(take(1))
        .subscribe((result) => {
          let itemIndex = this.formData.overflowValues.value
            .findIndex(item => item.overflowCustomInteractionQueueConfigId == result.oldOverflow.overflowCustomInteractionQueueConfigId
              && item.order == result.oldOverflow.order);

          this.formData.overflowValues
            .value[itemIndex].overflowCustomInteractionQueueConfigId = result.newOverflow.overflowCustomInteractionQueueConfigId;
          this.formData.overflowValues
            .value[itemIndex].overflowCustomInteractionQueueConfigName = result.newOverflow.overflowCustomInteractionQueueConfigName;
          this.formData.overflowValues.value[itemIndex].order = result.newOverflow.order;
          this.componentForm.updateValueAndValidity();
        });
    } else {
      this.errorMessage = 'Erro: Sessão expirada.';
    }
  }

  getOverflowConfigsParam() {
    this.errorMessage = '';
    const customId = this.customQueueConfig ? this.customQueueConfig.id : undefined;
    let configs = this.availableCustomInteractionQueues
      .filter(f => f.isDefault == false && f.id !== customId);

    return configs;
  }

  removeOverflow(itemOverflow) {
    this.errorMessage = '';
    let alert: any;
    alert = this.modalService.showConfirmModal('Confirmação de Exclusão de Transbordo',
      `Confirma a exclusão do transbordo?`);
    alert.then((result) => {
      if (result.value) {
        this.formData.overflowValues.value.splice(this.formData.overflowValues.value.indexOf(itemOverflow), 1);
      }
    });
  }

  /*Metadata*/
  metadataModalTitle = 'Configuração do metadado';
  destEditMetadata: any = EditQueueMetadataModalComponent;
  addMetadata() {
    this.errorMessage = '';
    let configuredMetadata = this.formData.metadataValues.value.map(m => m.structure);
    configuredMetadata = configuredMetadata.map(m => m.metadataStructureId);
    let param = {
      configuredMetadata: configuredMetadata
    };

    const result$ = this.modalService.showObjModal(this.destEditMetadata, this.metadataModalTitle, param, 'modal-md');
    if (result$) {
      result$.asObservable()
        .pipe(take(1))
        .subscribe((result) => {
          if (result) {
            this.formData.metadataValues.value.push({ structure: result.newStructure, values: result.values });
          }
        });
    } else {
      this.errorMessage = 'Erro: Sessão expirada.';
    }
  }

  editMetadata(itemMetadata) {
    this.errorMessage = '';
    let configuredMetadata = this.formData.metadataValues.value.map(m => m.structure);
    configuredMetadata = configuredMetadata.filter(f => f.metadataStructureId !== itemMetadata.structure.metadataStructureId)
      .map(m => m.metadataStructureId);
    let param = {metadataValues: itemMetadata, configuredMetadata: configuredMetadata};

    const result$ = this.modalService.showObjModal(this.destEditMetadata, this.metadataModalTitle, param, 'modal-md');
    if (result$) {
      result$.asObservable()
        .pipe(take(1))
        .subscribe((result) => {
          let itemIndex = this.formData.metadataValues.value
            .findIndex(item => item.structure.metadataStructureId == result.oldStructure.metadataStructureId);
          this.formData.metadataValues.value[itemIndex].structure = result.newStructure;
          this.formData.metadataValues.value[itemIndex].values = result.values;
          this.componentForm.updateValueAndValidity();
        });
    } else {
      this.errorMessage = 'Erro: Sessão expirada.';
    }
  }

  removeMetadata(itemMetadata) {
    this.errorMessage = '';
    let alert: any;
    alert = this.modalService.showConfirmModal('Confirmação de Exclusão de Metadado',
      `Confirma a exclusão do Metadado?`);
    alert.then((result) => {
      if (result.value) {
        this.formData.metadataValues.value.splice(this.formData.metadataValues.value.indexOf(itemMetadata), 1);
      }
    });
  }

  validateSpecialChars(control: AbstractControl) {
    const val = control.value;
    if (/[!@#$%¨&\(\)\[\]?:;.,<>/=+§]/g.test(val)) { return { 'hasSpecialChars': true }; }
    return null;
  }

  adjustSpaces(value, formControlName) {
    Utils.adjustSpaces(value, this.componentForm, formControlName);
  }
}
